import { GetChangelogRequest, GetChangelogResponse } from "@somewear/api";
import { grpc, someGrpc } from "@somewear/grpc";
import { ActionSetEpic, createActionSetEpicHandler } from "@somewear/model";
import { combineEpics } from "redux-observable";

import { changelogActions } from "./changelog.actions";

const getChangelogEpic: ActionSetEpic<
	GetChangelogRequest.AsObject,
	GetChangelogResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(action$, state$, changelogActions.getChangelog, (payload) =>
		grpc.prepareRequestWithPayload(someGrpc.fetchChangelogs, payload.data),
	);
};

export const changelogEpics = combineEpics(getChangelogEpic);
